import { API_ENDPOINTS } from "../config/chargerApiConfig";

export function parcelRecordId(parcelOrId) {
    const raw = parcelOrId && typeof parcelOrId === "object"
        ? (parcelOrId.id ?? parcelOrId.properties?.id)
        : parcelOrId;
    const id = Number(raw);
    return Number.isInteger(id) && id > 0 ? id : null;
}

function authHeaders() {
    const token = localStorage.getItem("authToken");
    return {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Token ${token}` } : {}),
    };
}

export async function recordParcelEngagement(parcelOrId, event) {
    const parcelId = parcelRecordId(parcelOrId);
    if (!parcelId) return null;
    try {
        const response = await fetch(API_ENDPOINTS.parcelEngagement, {
            method: "POST",
            headers: authHeaders(),
            body: JSON.stringify({ parcel_id: parcelId, event }),
        });
        return response.ok;
    } catch {
        return false;
    }
}
